import dayjs from 'dayjs'

export const BEHAVIOUR_NOTE_FORM_INPUTS = [
  {
    label: 'Client',
    name: 'clientId',
    type: 'searchableSelect',
    options: [],
    disabled: false,
    required: true,
    rowNumber: 3,
  },
  {
    sectionHeading: 'Danger To',
    rowNumber: 4,
  },
  {
    name: 'dangerTo',
    type: 'checkbox',
    required: true,
    rowNumber: 4,
    options: [
      {
        label: 'None',
        value: 'None',
      },
      {
        label: 'Self',
        value: 'Self',
      },
      {
        label: 'Others',
        value: 'Others',
      },
      {
        label: 'Ideation',
        value: 'Ideation',
      },
      {
        label: 'Plan',
        value: 'Plan',
      },
      {
        label: 'Intent',
        value: 'Intent',
      },
      {
        label: 'Attempt',
        value: 'Attempt',
      },
    ],
  },

  {
    sectionHeading: 'Behavior Analysis',
    rowNumber: 5,
  },
  {
    label: 'Status',
    name: 'status',
    type: 'select',
    options: [
      { label: 'No Change', value: 'No change' },
      { label: 'Improvement', value: 'Improvement' },
      { label: 'Set Back', value: 'Set Back' },
      { label: 'Deteriorating', value: 'Deteriorating' },
    ],
    required: true,
    rowNumber: 6,
  },
  {
    label: 'Response to TX',
    name: 'responseToTx',
    type: 'select',
    options: [
      { label: 'Cooperative', value: 'Cooperative' },
      { label: 'Uninterested', value: 'Uninterested' },
      { label: 'Engaged', value: 'Engaged' },
      { label: 'Combative', value: 'Combative' },
    ],
    required: true,
    rowNumber: 6,
  },
  {
    label: 'Appearance',
    name: 'appearance',
    type: 'select',
    options: [
      { label: 'Appropriate', value: 'Appropriate' },
      { label: 'Inappropriate', value: 'Inappropriate' },
      { label: 'Disheveled', value: 'Disheveled' },
      { label: 'Poor', value: 'Poor' },
    ],
    required: true,
    rowNumber: 6,
  },
  {
    label: 'Judgement',
    name: 'judgment',
    type: 'select',
    options: [
      { label: 'Excellent', value: 'Excellent' },
      { label: 'Good', value: 'Good' },
      { label: 'Fair', value: 'Fair' },
      { label: 'Poor', value: 'Poor' },
    ],
    required: true,
    rowNumber: 7,
  },
  {
    label: 'Insights',
    name: 'insights',
    type: 'select',
    options: [
      { label: 'Full', value: 'Full' },
      { label: 'Partial', value: 'Partial' },
      { label: 'Limited', value: 'Limited' },
      { label: 'None', value: 'None' },
    ],
    required: true,
    rowNumber: 7,
  },
  {
    label: 'Speech',
    name: 'speech',
    type: 'select',
    options: [
      { label: 'Appropriate', value: 'Appropriate' },
      { label: 'Slurred', value: 'Slurred' },
      { label: 'Rapid', value: 'Rapid' },
      { label: 'Pressured', value: 'Pressured' },
    ],
    required: true,
    rowNumber: 7,
  },
  {
    label: 'Mood',
    name: 'mood',
    type: 'select',
    options: [
      { label: 'Depressed', value: 'Depressed' },
      { label: 'Anxious', value: 'Anxious' },
      { label: 'Irritable', value: 'Irritable' },
      { label: 'Angry', value: 'Angry' },
      { label: 'Elevated', value: 'Elevated' },
    ],
    required: true,
    rowNumber: 8,
  },
  {
    label: 'Behavior',
    name: 'behavior',
    type: 'select',
    options: [
      { label: 'Appropriate', value: 'Appropriate' },
      { label: 'Hostile', value: 'Hostile' },
      { label: 'Distant/Distracted', value: 'Distant/Distracted' },
      { label: 'Agitated', value: 'Agitated' },
      { label: 'Poor Eye Contact', value: 'Poor Eye Contact' },
    ],
    required: true,
    rowNumber: 8,
  },
  {
    label: 'Thought Content',
    name: 'thoughtContent',
    type: 'select',
    options: [
      { label: 'Pre Occupied', value: 'Pre Occupied' },
      { label: 'Hallucinations', value: 'Hallucinations' },
      { label: 'Delusion', value: 'Delusion' },
      { label: 'Depersonalized', value: 'Depersonalized' },
      { label: 'False Beliefs', value: 'False Beliefs' },
      { label: 'Irrelevant Detail', value: 'Irrelevant Detail' },
    ],
    required: true,
    rowNumber: 8,
  },
  {
    label: 'Thought Process',
    name: 'thoughtProcess',
    type: 'select',
    options: [
      { label: 'Circumstantial', value: 'Circumstantial' },
      { label: 'Loose', value: 'Loose' },
      { label: 'Tangential', value: 'Tangential' },
      { label: 'Ideal Flight', value: 'Ideal Flight' },
    ],
    required: true,
    rowNumber: 9,
  },
  {
    label: 'Orientation',
    name: 'orientation',
    type: 'select',
    options: [
      { label: 'Person', value: 'Person' },
      { label: 'Place', value: 'Place' },
      { label: 'Time', value: 'Time' },
      { label: 'Situation', value: 'Situation' },
    ],
    required: true,
    rowNumber: 9,
  },
  {
    label: 'Affect',
    name: 'affect',
    type: 'select',
    options: [
      { label: 'Blunt', value: 'Blunt' },
      { label: 'Depressed', value: 'Depressed' },
      { label: 'Flat', value: 'Flat' },
      { label: 'Expansive', value: 'Expansive' },
      { label: 'Euthymic', value: 'Euthymic' },
      { label: 'Dysphoric', value: 'Dysphoric' },
      { label: 'Constructed', value: 'Constructed' },
    ],
    required: true,
    rowNumber: 9,
  },
  {
    sectionHeading: 'Therapeutic Interventions',
    rowNumber: 11,
  },
  {
    name: 'therapeuticInterventions',
    type: 'checkbox',
    options: [
      { label: 'Client Centered Therapy', value: 'Client Centered Therapy' },
      { label: 'Psychoeducation', value: 'Psychoeducation' },
      { label: 'Systemic Family Therapy', value: 'Systemic Family Therapy' },
      { label: 'EMDR', value: 'EMDR' },
      { label: 'DBT', value: 'DBT' },
      { label: 'Positive Psychology', value: 'Positive Psychology' },
      { label: 'Play/Art Therapy', value: 'Play/Art Therapy' },
      { label: 'Humanistic Therapy', value: 'Humanistic Therapy' },
      { label: 'Anger Management', value: 'Anger Management' },
      { label: 'Problem Solving Skills', value: 'Problem Solving Skills' },
      { label: 'Cognitive Restructuring', value: 'Cognitive Restructuring' },
      { label: 'Existential Therapy', value: 'Existential Therapy' },
      { label: 'Attachment Therapy', value: 'Attachment Therapy' },
      { label: 'Solution - Focused', value: 'Solution - Focused' },
      { label: 'Roleplay', value: 'Roleplay' },
      { label: 'Grief Processing', value: 'Grief Processing' },
      { label: 'Coping Skills', value: 'Coping Skills' },
      { label: 'Supportive Reflections', value: 'Supportive Reflections' },
      { label: 'Communication Training', value: 'Communication Training' },
      { label: 'Crisis Intervention', value: 'Crisis Intervention' },
      { label: 'Stress Management', value: 'Stress Management' },
      { label: 'Building Support', value: 'Building Support' },
      { label: 'Mindfulness Training', value: 'Mindfulness Training' },
      { label: 'Trauma Focused CBT', value: 'Trauma Focused CBT' },
    ],
    required: true,
    rowNumber: 12,
  },
  {
    sectionHeading: 'History of Patient illness',
    rowNumber: 13,
  },
  {
    label: 'Location',
    name: 'location',
    type: 'text',
    required: true,
    rowNumber: 14,
  },
  {
    label: 'Duration',
    name: 'duration',
    type: 'text',
    required: true,
    rowNumber: 14,
  },
  {
    label: 'Timing',
    name: 'timing',
    type: 'text',
    required: true,
    rowNumber: 14,
  },
  {
    label: 'Associated Symptoms',
    name: 'associatedSymptoms',
    type: 'text',
    required: true,
    rowNumber: 15,
  },
  {
    label: 'Medical Hx',
    name: 'medicalHx',
    type: 'text',
    required: true,
    rowNumber: 15,
  },
  // {
  //   sectionHeading: 'Goal/Objectives',
  //   rowNumber: 16,
  // },

  {
    label: 'Goal/Objectives',
    name: 'goalsObjectives',
    type: 'textarea',
    required: false,
    minRows: 2,
    rowNumber: 17,
  },
  // {
  //   sectionHeading: 'Evidence Of Patient Response',
  //   rowNumber: 18,
  // },

  {
    label: 'Evidence Of Patient Response',
    name: 'evidenceOfResponse',
    type: 'textarea',
    required: false,
    minRows: 2,
    rowNumber: 19,
  },

  // {
  //   sectionHeading: 'Intervention Studies Implemented /Session Focus On Theme',
  //   rowNumber: 20,
  // },

  {
    label: 'Intervention Studies Implemented /Session Focus On Theme',
    name: 'interventionStudies',
    type: 'textarea',
    required: false,
    minRows: 2,
    rowNumber: 21,
  },
  // {
  //   sectionHeading: 'Session Content',
  //   rowNumber: 22,
  // },

  {
    label: 'Session Content',
    name: 'sessionContent',
    type: 'textarea',
    required: false,
    minRows: 3,
    rowNumber: 23,
  },
  // {
  //   sectionHeading: 'Future Treatment/Follow up Issues',
  //   rowNumber: 24,
  // },

  {
    label: 'Future Treatment/Follow up Issues',
    name: 'futureTreatment',
    type: 'textarea',
    required: false,
    minRows: 3,
    rowNumber: 25,
  },
  // {
  //   sectionHeading: 'Assigned Homework',
  //   rowNumber: 26,
  // },

  {
    label: 'Assigned Homework',
    name: 'assignedHomework',
    type: 'textarea',
    required: false,
    minRows: 3,
    rowNumber: 27,
  },

  {
    label: 'Next Appointment',
    name: 'nextAppointment',
    minDate: dayjs().toDate(),
    type: 'date',
    required: true,
    rowNumber: 28,
  },
  // {
  //   label: 'Therapist Signature',
  //   name: 'therapistSignature',
  //   type: 'text',
  //   required: true,
  //   rowNumber: 28,
  // },
  // {
  //   label: 'Date',
  //   name: 'dateSigned',
  //   type: 'date',
  //   required: true,
  //   rowNumber: 28,
  // },
]
export const EDIT_BEHAVIOUR_NOTE_FORM_INPUTS = [
  {
    label: 'Client',
    name: 'clientId',
    type: 'searchableSelect',
    options: [],
    disabled: false,
    required: true,
    rowNumber: 3,
  },
  {
    sectionHeading: 'Danger To',
    rowNumber: 4,
  },
  {
    name: 'dangerTo',
    type: 'checkbox',
    required: true,
    rowNumber: 4,
    options: [
      {
        label: 'None',
        value: 'None',
      },
      {
        label: 'Self',
        value: 'Self',
      },
      {
        label: 'Others',
        value: 'Others',
      },
      {
        label: 'Ideation',
        value: 'Ideation',
      },
      {
        label: 'Plan',
        value: 'Plan',
      },
      {
        label: 'Intent',
        value: 'Intent',
      },
      {
        label: 'Attempt',
        value: 'Attempt',
      },
    ],
  },

  {
    sectionHeading: 'Behavior Analysis',
    rowNumber: 5,
  },
  {
    label: 'Status',
    name: 'status',
    type: 'select',
    options: [
      { label: 'No Change', value: 'No change' },
      { label: 'Improvement', value: 'Improvement' },
      { label: 'Set Back', value: 'Set Back' },
      { label: 'Deteriorating', value: 'Deteriorating' },
    ],
    required: true,
    rowNumber: 6,
  },
  {
    label: 'Response to TX',
    name: 'responseToTx',
    type: 'select',
    options: [
      { label: 'Cooperative', value: 'Cooperative' },
      { label: 'Uninterested', value: 'Uninterested' },
      { label: 'Engaged', value: 'Engaged' },
      { label: 'Combative', value: 'Combative' },
    ],
    required: true,
    rowNumber: 6,
  },
  {
    label: 'Appearance',
    name: 'appearance',
    type: 'select',
    options: [
      { label: 'Appropriate', value: 'Appropriate' },
      { label: 'Inappropriate', value: 'Inappropriate' },
      { label: 'Disheveled', value: 'Disheveled' },
      { label: 'Poor', value: 'Poor' },
    ],
    required: true,
    rowNumber: 6,
  },
  {
    label: 'Judgement',
    name: 'judgment',
    type: 'select',
    options: [
      { label: 'Excellent', value: 'Excellent' },
      { label: 'Good', value: 'Good' },
      { label: 'Fair', value: 'Fair' },
      { label: 'Poor', value: 'Poor' },
    ],
    required: true,
    rowNumber: 7,
  },
  {
    label: 'Insights',
    name: 'insights',
    type: 'select',
    options: [
      { label: 'Full', value: 'Full' },
      { label: 'Partial', value: 'Partial' },
      { label: 'Limited', value: 'Limited' },
      { label: 'None', value: 'None' },
    ],
    required: true,
    rowNumber: 7,
  },
  {
    label: 'Speech',
    name: 'speech',
    type: 'select',
    options: [
      { label: 'Appropriate', value: 'Appropriate' },
      { label: 'Slurred', value: 'Slurred' },
      { label: 'Rapid', value: 'Rapid' },
      { label: 'Pressured', value: 'Pressured' },
    ],
    required: true,
    rowNumber: 7,
  },
  {
    label: 'Mood',
    name: 'mood',
    type: 'select',
    options: [
      { label: 'Depressed', value: 'Depressed' },
      { label: 'Anxious', value: 'Anxious' },
      { label: 'Irritable', value: 'Irritable' },
      { label: 'Angry', value: 'Angry' },
      { label: 'Elevated', value: 'Elevated' },
    ],
    required: true,
    rowNumber: 8,
  },
  {
    label: 'Behavior',
    name: 'behavior',
    type: 'select',
    options: [
      { label: 'Appropriate', value: 'Appropriate' },
      { label: 'Hostile', value: 'Hostile' },
      { label: 'Distant/Distracted', value: 'Distant/Distracted' },
      { label: 'Agitated', value: 'Agitated' },
      { label: 'Poor Eye Contact', value: 'Poor Eye Contact' },
    ],
    required: true,
    rowNumber: 8,
  },
  {
    label: 'Thought Content',
    name: 'thoughtContent',
    type: 'select',
    options: [
      { label: 'Pre Occupied', value: 'Pre Occupied' },
      { label: 'Hallucinations', value: 'Hallucinations' },
      { label: 'Delusion', value: 'Delusion' },
      { label: 'Depersonalized', value: 'Depersonalized' },
      { label: 'False Beliefs', value: 'False Beliefs' },
      { label: 'Irrelevant Detail', value: 'Irrelevant Detail' },
    ],
    required: true,
    rowNumber: 8,
  },
  {
    label: 'Thought Process',
    name: 'thoughtProcess',
    type: 'select',
    options: [
      { label: 'Circumstantial', value: 'Circumstantial' },
      { label: 'Loose', value: 'Loose' },
      { label: 'Tangential', value: 'Tangential' },
      { label: 'Ideal Flight', value: 'Ideal Flight' },
    ],
    required: true,
    rowNumber: 9,
  },
  {
    label: 'Orientation',
    name: 'orientation',
    type: 'select',
    options: [
      { label: 'Person', value: 'Person' },
      { label: 'Place', value: 'Place' },
      { label: 'Time', value: 'Time' },
      { label: 'Situation', value: 'Situation' },
    ],
    required: true,
    rowNumber: 9,
  },
  {
    label: 'Affect',
    name: 'affect',
    type: 'select',
    options: [
      { label: 'Blunt', value: 'Blunt' },
      { label: 'Depressed', value: 'Depressed' },
      { label: 'Flat', value: 'Flat' },
      { label: 'Expansive', value: 'Expansive' },
      { label: 'Euthymic', value: 'Euthymic' },
      { label: 'Dysphoric', value: 'Dysphoric' },
      { label: 'Constructed', value: 'Constructed' },
    ],
    required: true,
    rowNumber: 9,
  },
  {
    sectionHeading: 'Therapeutic Interventions',
    rowNumber: 11,
  },
  {
    name: 'therapeuticInterventions',
    type: 'checkbox',
    options: [
      { label: 'Client Centered Therapy', value: 'Client Centered Therapy' },
      { label: 'Psychoeducation', value: 'Psychoeducation' },
      { label: 'Systemic Family Therapy', value: 'Systemic Family Therapy' },
      { label: 'EMDR', value: 'EMDR' },
      { label: 'DBT', value: 'DBT' },
      { label: 'Positive Psychology', value: 'Positive Psychology' },
      { label: 'Play/Art Therapy', value: 'Play/Art Therapy' },
      { label: 'Humanistic Therapy', value: 'Humanistic Therapy' },
      { label: 'Anger Management', value: 'Anger Management' },
      { label: 'Problem Solving Skills', value: 'Problem Solving Skills' },
      { label: 'Cognitive Restructuring', value: 'Cognitive Restructuring' },
      { label: 'Existential Therapy', value: 'Existential Therapy' },
      { label: 'Attachment Therapy', value: 'Attachment Therapy' },
      { label: 'Solution - Focused', value: 'Solution - Focused' },
      { label: 'Roleplay', value: 'Roleplay' },
      { label: 'Grief Processing', value: 'Grief Processing' },
      { label: 'Coping Skills', value: 'Coping Skills' },
      { label: 'Supportive Reflections', value: 'Supportive Reflections' },
      { label: 'Communication Training', value: 'Communication Training' },
      { label: 'Crisis Intervention', value: 'Crisis Intervention' },
      { label: 'Stress Management', value: 'Stress Management' },
      { label: 'Building Support', value: 'Building Support' },
      { label: 'Mindfulness Training', value: 'Mindfulness Training' },
      { label: 'Trauma Focused CBT', value: 'Trauma Focused CBT' },
    ],
    required: true,
    rowNumber: 12,
  },
  {
    sectionHeading: 'History of Patient illness',
    rowNumber: 13,
  },
  {
    label: 'Location',
    name: 'location',
    type: 'text',
    required: true,
    rowNumber: 14,
  },
  {
    label: 'Duration',
    name: 'duration',
    type: 'text',
    required: true,
    rowNumber: 14,
  },
  {
    label: 'Timing',
    name: 'timing',
    type: 'text',
    required: true,
    rowNumber: 14,
  },
  {
    label: 'Associated Symptoms',
    name: 'associatedSymptoms',
    type: 'text',
    required: true,
    rowNumber: 15,
  },
  {
    label: 'Medical Hx',
    name: 'medicalHx',
    type: 'text',
    required: true,
    rowNumber: 15,
  },
  // {
  //   sectionHeading: 'Goal/Objectives',
  //   rowNumber: 16,
  // },

  {
    label: 'Goal/Objectives',
    name: 'goalsObjectives',
    type: 'textarea',
    required: false,
    minRows: 2,
    rowNumber: 17,
  },
  // {
  //   sectionHeading: 'Evidence Of Patient Response',
  //   rowNumber: 18,
  // },

  {
    label: 'Evidence Of Patient Response',
    name: 'evidenceOfResponse',
    type: 'textarea',
    required: false,
    minRows: 2,
    rowNumber: 19,
  },

  // {
  //   sectionHeading: 'Intervention Studies Implemented /Session Focus On Theme',
  //   rowNumber: 20,
  // },

  {
    label: 'Intervention Studies Implemented /Session Focus On Theme',
    name: 'interventionStudies',
    type: 'textarea',
    required: false,
    minRows: 2,
    rowNumber: 21,
  },
  // {
  //   sectionHeading: 'Session Content',
  //   rowNumber: 22,
  // },

  {
    label: 'Session Content',
    name: 'sessionContent',
    type: 'textarea',
    required: false,
    minRows: 3,
    rowNumber: 23,
  },
  // {
  //   sectionHeading: 'Future Treatment/Follow up Issues',
  //   rowNumber: 24,
  // },

  {
    label: 'Future Treatment/Follow up Issues',
    name: 'futureTreatment',
    type: 'textarea',
    required: false,
    minRows: 3,
    rowNumber: 25,
  },
  // {
  //   sectionHeading: 'Assigned Homework',
  //   rowNumber: 26,
  // },

  {
    label: 'Assigned Homework',
    name: 'assignedHomework',
    type: 'textarea',
    required: false,
    minRows: 3,
    rowNumber: 27,
  },

  {
    label: 'Next Appointment',
    name: 'nextAppointment',
    minDate: dayjs().toDate(),
    type: 'date',
    required: true,
    rowNumber: 28,
  },
  // {
  //   label: 'Therapist Signature',
  //   name: 'therapistSignature',
  //   type: 'text',
  //   required: true,
  //   rowNumber: 28,
  // },
  // {
  //   label: 'Date',
  //   name: 'dateSigned',
  //   type: 'date',
  //   required: true,
  //   rowNumber: 28,
  // },
]
export const BEHAVIOUR_NOTE_FORM_INPUTS_DATA = {
  startDate: '',
  endDate: '',
  noteType: '',
  clientId: '',
  dangerTo: '',
  status: '',
  responseToTx: '',
  appearance: '',
  judgment: '',
  insights: '',
  speech: '',
  mood: '',
  behaviour: '',
  thoughtContent: '',
  thoughtProcess: '',
  orientation: '',
  affect: '',
  therapeuticInterventions: [],
  location: '',
  duration: '',
  timing: '',
  associatedSymptoms: '',
  medicalHx: '',
  goalsObjectives: '',
  evidenceOfResponse: '',
  interventionStudies: '',
  sessionContent: '',
  futureTreatment: '',
  assignedHomework: '',
  nextAppointment: '',
  therapistSignature: '',
  dateSigned: '',
}

export const BEHAVIOUR_ASSESSMENT_FORM_INPUTS = [
  {
    type: 'sectionTitle',
    title: 'PARTICIPANT DETAILS',
    rowNumber: 1,
  },
  {
    label: 'Client',
    name: 'clientId',
    type: 'searchableSelect',
    options: [],
    disabled: false,
    required: true,
    rowNumber: 2,
  },
  {
    targetAndBehaviour: true,
    rowNumber: 3,
  },
  {
    sectionHeading: 'Disability Type',
    rowNumber: 4,
  },
  {
    label: 'Type 1',
    name: 'type1',
    type: 'text',
    required: false,
    rowNumber: 5,
  },
  {
    label: 'Type 2',
    name: 'type2',
    type: 'text',
    required: false,
    rowNumber: 5
  },
  {
    label: 'Type 3',
    name: 'type3',
    type: 'text',
    required: false,
    rowNumber: 5,
  },
  {
    sectionHeading: 'KEY CONTACTS',
    rowNumber: 6,
  },
  {
    label: 'Name',
    name: 'name1',
    type: 'text',
    required: false,
    rowNumber: 7,
  },
  {
    label: 'Relationship',
    name: 'relationship1',
    type: 'text',
    required: false,
    rowNumber: 7,
  },
  {
    label: 'Phone',
    name: 'phoneNumber1',
    type: 'phoneNumber',
    required: false,
    rowNumber: 7,
  },
  {
    label: 'Name',
    name: 'name2',
    type: 'text',
    required: false,
    rowNumber: 8,
  },
  {
    label: 'Relationship',
    name: 'relationship2',
    type: 'text',
    required: false,
    rowNumber: 8,
  },
  {
    label: 'Phone',
    name: 'phoneNumber2',
    type: 'phoneNumber',
    required: false,
    rowNumber: 8,
  },
  {
    sectionHeading: 'PLAN PREPARED BY',
    rowNumber: 9,
  },
  {
    label: 'Name',
    name: 'name',
    type: 'text',
    required: false,
    rowNumber: 10,
  },
  {
    label: 'Profession',
    name: 'profession',
    type: 'text',
    required: false,
    rowNumber: 10,
  },
  {
    label: 'Registration Number',
    name: 'registrationNumber',
    type: 'text',
    required: false,
    rowNumber: 10,
  },
  {
    type: 'sectionTitle',
    title: 'BEHAVIORS OF CONCERN',
    rowNumber: 11,
  },
  {
    label: 'Type',
    placeholder: 'Insert type of behavior (e.g. self-harm or aggressive behaviors).',
    name: 'type',
    type: 'textarea',
    required: false,
    rowNumber: 12,
  },
  {
    label: 'Description',
    placeholder: 'Outline the details of the behavior (e.g. what does it look like, who is affected etc).',
    name: 'description',
    type: 'textarea',
    required: false,
    rowNumber: 13,
  },
  {
    label: 'Frequency/Duration',
    placeholder: 'Outline how often the behavior occurs and how long it lasts for.',
    name: 'duration',
    type: 'textarea',
    required: false,
    rowNumber: 14,
  },
  {
    label: 'Intensity',
    placeholder: 'Specify the intensity of the behavior(s).',
    name: 'intensity',
    type: 'textarea',
    required: false,
    rowNumber: 15,
  },
  {
    label: 'Setting Events',
    placeholder: 'Outline environmental factors and situations that make the behaviors more likely to occur.',
    name: 'settingEvents',
    type: 'textarea',
    required: false,
    rowNumber: 16,
  },
  {
    label: 'Triggers',
    placeholder: 'Specify specific triggers that sets of the behaviors.',
    name: 'triggers',
    type: 'textarea',
    required: false,
    rowNumber: 17,
  },
  {
    label: 'Low Risk Scenarios',
    placeholder: 'Outline low risk scenarios when the behavior is present.',
    name: 'lowRiskScenarios',
    type: 'textarea',
    required: false,
    rowNumber: 18,
  },
  {
    label: 'High Risk Scenarios',
    placeholder: 'Outline high risk scenarios when the behavior is present.',
    name: 'highRiskScenarios',
    type: 'textarea',
    required: false,
    rowNumber: 19,
  },
  {
    label: 'Function of the Behavior',
    placeholder: 'Outline what the function of the behavior is for the participant.',
    name: 'function',
    type: 'textarea',
    required: false,
    rowNumber: 20,
  },
  {
    label: 'Functionally Equivalent Replacement Behavior',
    placeholder: 'Identify replacement behaviors that could achieve the same function of the above behavior, but without causing risk to the participants or others.',
    name: 'replacementBehaviour',
    type: 'textarea',
    required: false,
    rowNumber: 21,
  },
  {
    label: 'Behavioral Goals',
    placeholder: 'Specify the goals of the positive behavior support plan.',
    name: 'behaviouralGoals',
    type: 'textarea',
    required: false,
    rowNumber: 22,
  },
  {
    sectionHeading: 'Baseline & Prevention of the Behavior',
    rowNumber: 23,
  },
  {
    label: 'What this looks like',
    name: 'baselineAndPreventionLooksLike',
    type: 'textarea',
    required: false,
    rowNumber: 24,
  },
  {
    label: 'What the participant can do',
    name: 'baselineAndPreventionParticipantCanDo',
    type: 'textarea',
    required: false,
    rowNumber: 25,
  },
  {
    label: 'What the support team can do',
    name: 'baselineAndPreventionSupportTeamCanDo',
    type: 'textarea',
    required: false,
    rowNumber: 26,
  },
  {
    sectionHeading: 'Build up to the Behavior',
    rowNumber: 27,
  },
  {
    label: 'What this looks like',
    name: 'buildUpLooksLike',
    type: 'textarea',
    required: false,
    rowNumber: 28,
  },
  {
    label: 'What the participant can do',
    name: 'buildUpParticipantCanDo',
    type: 'textarea',
    required: false,
    rowNumber: 29,
  },
  {
    label: 'What the support team can do',
    name: 'buildUpSupportTeamCanDo',
    type: 'textarea',
    required: false,
    rowNumber: 30,
  },
  {
    sectionHeading: 'When the behavior is occurring',
    rowNumber: 31,
  },
  {
    label: 'What this looks like',
    name: 'whenLooksLike',
    type: 'textarea',
    required: false,
    rowNumber: 32,
  },
  {
    label: 'What the participant can do',
      name: 'whenParticipantCanDo',
    type: 'textarea',
    required: false,
    rowNumber: 33,
  },
  {
    label: 'What the support team can do',
    name: 'whenSupportTeamCanDo',
    type: 'textarea',
    required: false,
    rowNumber: 34,
  },
  {
    sectionHeading: 'Formulation',
    rowNumber: 35,
  },
  {
    label: 'Outline the formulation for the participants’ symptoms and behaviors.',
    name: 'formulation',
    type: 'textarea',
    required: false,
    rowNumber: 36,
  },
  {
    sectionHeading: 'Preventative/environmental strategies',
    rowNumber: 37,
  },
  {
    label: 'Outline any preventative and environmental strategies that will help the participant minimise the unhelpful behaviors.',
    name: 'preventativeStrategies',
    type: 'textarea',
    required: false,
    rowNumber: 38,
  },
  {
    sectionHeading: 'Skill-building/teachingstrategies',
    rowNumber: 39,
  },
  {
    label: 'Outline any educational or skill-building activities the support team can assist the participant in developing as part of the positive behavior plan.',
    name: 'skillBuildingStrategies',
    type: 'textarea', 
    required: false,
    rowNumber: 40,
  },
  {
    sectionHeading: 'Reinforcement/motivation',
    rowNumber: 41,
  },
  {
    label: 'Identify and outline the current motivation for engagement in replacement behaviors, any barriers to engagement in the plan and how they will be addressed.',
    name: 'reinforcementMotivation',
    type: 'textarea', 
    required: false,
    rowNumber: 42,
  },
  {
    sectionHeading: 'Plan implementation/system supports',
    rowNumber: 43,
  },
  {
    label: 'Identify and outline who is recommended to be included in the participant’s support team and who should receive a copy of the behavior support plan.',
    name: 'planImplementationSystemSupports',
    type: 'textarea', 
    required: false,
    rowNumber: 44,
  }
]
export const BEHAVIOUR_ASSESSMENT_FORM_INPUTS_DATA = {
  clientId: '',
  disability: {
    type1: '',
    type2: '',
    type3: '',
  },
  keyContacts: [
    {
      name: '',
      relationship: '',
      phoneNumber: '',
    },
    {
      name: '',
      relationship: '',
      phoneNumber: '',
    } 
  ],
  planPreparedBy: {
    name: '',
    profession: '',
    registrationNumber: '',
  },
  behaviourOfConcern: {
    type: '',
    description: '',
    duration: '',
    intensity: '',
    settingEvents: '',
    triggers: '',
    lowRiskScenarios: '',
    highRiskScenarios: '',
    function: '',
    replacementBehaviour: '',
    behaviouralGoals: '',
  },
  baselineAndPrevention: {
    baselineAndPreventionLooksLike: '',
    baselineAndPreventionParticipantCanDo: '',
    baselineAndPreventionSupportTeamCanDo: '',
  },
  buildUp: {
    buildUpLooksLike: '',
    buildUpParticipantCanDo: '',
    buildUpSupportTeamCanDo: '',
  },
  when: {
    whenLooksLike: '',
    whenParticipantCanDo: '',
    whenSupportTeamCanDo: '',
  },
  formulation: '',
  preventativeStrategies: '',
  skillBuildingStrategies: '',
  reinforcementMotivation: '',
  planImplementationSystemSupports: '',
}